<template>
  <label>
    {{ label }}
    <input class="form-control" :type="type === 'date' ? 'text' : type" v-model="val" @input="onInput" @click="click"
           @blur="blur" :placeholder="placeholder" :disabled="disabled" v-mask="mask">
    <div class="num" v-if="type === 'number' && numberButtons">
      <i v-if="parseInt(val, 10) !== 0 || val === null" @click="onClickMinus" class="min">-</i>
      <i class="plus" @click="onClickPlus">+</i>
    </div>
    <b class="error" v-if="error.invalid">{{ error.message }}</b>
  </label>
</template>
<script>

export default {
  name: 'CustomInput',
  props: {
    value: {
      type: String,
      default: null
    },
    element: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    numberButtons: {
      type: Boolean,
      default: false
    },
    isCred: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: null
    },
    minDate: {
      type: String,
      default: ''
    },
    mask: {
      type: String,
      default: ''
    },
    externalError: {
      type: String,
      default: ''
    },
    maxYear: {
      type: Number,
      default() {
        return (new Date()).getFullYear();
      },
    }
    //
  },
  data() {
    return {
      val: null,
      error: {
        invalid: false,
        message: ''
      },
    }
  },
  mounted() {
    this.val = this.value
  },
  methods: {
    ucFirst(str) {
      if (!str) {
        return str;
      }
      return str[0].toUpperCase() + str.slice(1);
    },
    onInput(event) {
      let val = event.target.value
      if (this.isCred && val) {
        this.val = this.ucFirst(val);
      }
      this.$emit('input', val)
    },
    blur(event) {

      if (this.limit) {
        this.val = this.val.substr(0, this.limit)
      }

      if (this.type === 'date' && this.val) {
        this.error.invalid = false;
        this.error.message = '';
        const split = this.val.split('.');
        if (split.length < 3) {
          this.error.invalid = true;
          this.error.message = 'Некорректная дата';
        } else if (split[2].length < 4) {
          this.error.invalid = true;
          this.error.message = 'Некорректная дата';
        } else if (this.minDate) {
          const splitMin = this.minDate.split('.');
          if (splitMin[2] > split[2]) {
            this.error.invalid = true;
            this.error.message = 'Некорректная дата';
          }
        }
      }

      this.$emit('blur', event.target.value)
    },
    click(event) {
      this.$emit('click', event);
      this.$emit('input', event.target.value);
    },
    onClickMinus(event) {
      this.val = parseInt(this.val, 10) - 1;
      this.$emit('input', event.target.value)
    },
    onClickPlus(event) {
      this.val = parseInt(this.val, 10) + 1;
      this.$emit('input', event.target.value)
    },
    stringToDate(dateString) {
      const dateArr = dateString.split('.');
      return (new Date(dateArr.reverse().join('-')));
    },
  },
  watch: {
    value() {
      if (this.type !== 'number') {
        this.val = this.value;
      }
      this.error.invalid = false;
      this.error.message = '';
      if (this.type === 'date' && this.val) {
        const split = this.val ? this.val.split('.') : null;
        if (split[2]) {
          if (split[2] > this.maxYear) {
            this.error.invalid = true;
            this.error.message = 'Некорректная дата';
          }
        }
      }
      if (this.val) {
        this.$emit('update:element', this.val.toString());
      }
    },
    val() {
      if (this.type !== 'number') {
        if (this.val === null) {
          this.val = ''
        }
        this.$emit('update:element', this.val.toString());
      }
    }
  }
}
</script>

<style scoped>
.row.g-1.g-lg-3 {
  margin-top: 0px;
}

label {
  width: 100%;
  font-weight: 600;
  color: #565656;
  position: relative;
  font-size: 0.85rem;
  margin-bottom: 0px;
}

.form-control {
  border-radius: 7px;
  height: 34px;
  border-color: #cdcdcd !important;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.4;
}

.form-control:focus {
  box-shadow: none;
}

.num {
  position: absolute;
  right: 8px;
  top: 13px;
  font-weight: 900;
  color: #9d9d9d;
  font-size: 31px;
  cursor: pointer;
  user-select: none;
}

.min {
  margin-right: 6px;
}

.error {
  color: red;
  font-size: 12px;
  font-weight: lighter;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
